import moment from 'moment';
export default {
    methods: {
        //funciones para el filtro
        customFilter(items, filters, filter, headers) {
            // Init the filter class.
            const cf = new this.$MultiFilters(items, filters, filter, headers);
            cf.registerFilter("nro_item", function (searchWord, items) {
                if (searchWord.trim() === "") return items;
                return items.filter(item => {
                    return (item.nro_item + "")
                        .toLowerCase()
                        .includes(searchWord.toLowerCase());
                }, searchWord);
            });
            cf.registerFilter("motivo", function (searchWord, items) {
                if (searchWord.trim() === "") return items;
                return items.filter(item => {
                    return (item.motivo + "")
                        .toLowerCase()
                        .includes(searchWord.toLowerCase());
                }, searchWord);
            });
            cf.registerFilter("nombre_unidad", function (searchWord, items) {
                if (searchWord.trim() === "") return items;
                return items.filter(item => {
                    return (item.nombre_unidad + "")
                        .toLowerCase()
                        .includes(searchWord.toLowerCase());
                }, searchWord);
            });
            cf.registerFilter("ci", function (searchWord, items) {
                if (searchWord.trim() === "") return items;
                return items.filter(item => {
                    return (item.ci + "")
                        .toLowerCase()
                        .includes(searchWord.toLowerCase());
                }, searchWord);
            });
            cf.registerFilter("nombre_completo", function (searchWord, items) {
                if (searchWord.trim() === "") return items;
                return items.filter(item => {
                    return (item.nombre_completo + "")
                        .toLowerCase()
                        .includes(searchWord.toLowerCase());
                }, searchWord);
            });

            return cf.runFilters();
        },
        filterNroItem(val) {
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                nro_item: val
            });
        },
        filterMotivo(val) {
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                motivo: val
            });
        },
        filterNombreUnidad(val) {
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                nombre_unidad: val
            });
        },
        filterCi(val) {
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                ci: val
            });
        },
        filterNombreCompleto(val) {
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                nombre_completo: val
            });
        },
        //-------------------------------------
        recargar() {
            this.form = {}
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                nro_item: ""
            });
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                fecha_registro: ""
            });
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                motivo: ""
            });
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                nombre_unidad: ""
            });
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                ci: ""
            });
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                nombre_completo: ""
            });
        },
    }
};


// WEBPACK FOOTER //
// ./src/components/admin/movilidad/mixins/Filtros.js